import BigNumber from 'bignumber.js'

import { PostResponse } from '@/model/post'
import { createAppAsyncThunk } from '@/redux/utils'
import { requestBaeApi } from '@/utils/axios'

export const postNamespace = 'post'

export interface ReadPostsResponse {
  posts: PostResponse[]
}

export interface ReadPostsRequest {
  creatorId: number
  limit?: number
  offset: number
  userId: number
}

export const readPosts = async ({
  creatorId,
  limit = 24,
  offset = 0,
  userId,
}: ReadPostsRequest) => {
  const {
    data: { posts },
  } = await requestBaeApi<ReadPostsResponse>({
    creatorId,
    url: '/co/v1/all',
    method: 'post',
    data: {
      page_num: BigNumber(offset).div(limit).plus(1).integerValue().toNumber(),
      records: limit,
      userid: userId,
    },
  })

  return {
    hasMore: posts.length === limit,
    list: posts,
  }
}

export interface ReadPostRequest {
  creatorId: number
  postId: number
}

export interface ReadPostResponse {
  media: PostResponse[]
}

export const readPost = async ({
  creatorId,
  postId,
}: ReadPostRequest) => {
  const result = await requestBaeApi<ReadPostResponse>({
    creatorId,
    url: `/api/v1/view_post/${postId}`,
  })
  return result.data.media[0]
}

export const getPosts = createAppAsyncThunk(
  `${postNamespace}/getPosts`,
  async (params: ReadPostsRequest) => {
    const result = await readPosts(params)
    return result
  },
)

export const deletePost = createAppAsyncThunk(
  `${postNamespace}/deletePost`,
  async (data: { uid: number; pid: number; creatorId: number }) => {
    const { pid, uid, creatorId } = data
    await requestBaeApi({
      creatorId,
      url: `/co/v1/post/${uid}/${pid}`,
      method: 'delete',
    })
    return true
  },
)